import React, { Component } from 'react';
import './style.css'
import AboutImg from './../../assets/about.png'
import AboutImg2 from './../../assets/about2.png'
import AboutImg3 from './../../assets/about3.png'
import TitleSection from '../../component/title';

const About=()=>{
    return (
        <section className='about' id='about'>
            <TitleSection>About</TitleSection>
            <div className="container-about">
                <div className="about-gallery">
                    <div className='about-content'>
                        <img src={AboutImg} alt=''/>
                        <div className="overlay">
                            <div className="text">Modeling</div>
                        </div>
                    </div>
                    <div className='about-content'>
                        <p>"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Rem, accusantium."</p>    
                    </div>
                    <div className='about-content'>
                        <img src={AboutImg2} alt=''/>
                        <div className="overlay">
                            <div className="text">Magic</div>
                        </div>
                    </div>
                </div>
                <div className="about-gallery">
                    <div className='about-content'>
                        <p>"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Rem, accusantium."</p>    
                    </div>
                    <div className='about-content'>
                        <img src={AboutImg3} alt=''/>
                        <div className="overlay">
                            <div className="text">Dance</div>
                        </div>
                    </div>
                    <div className='about-content'>
                        <p>"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Rem, accusantium."</p>    
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About